import template from './leaderboard.html'
import controller from './leaderboard.controller'
import service from './leaderboard.service'
import './leaderboard.scss'

let module = angular.module('leaderboard', [
	'ionic'
])
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.leaderboard', {
			url: '/leaderboard',
			views: {
				'tab-more': {
					template: template,
					controller: controller,
					controllerAs: 'leaderboard'
				}
			},
		})
})
.service('Leaderboard', service)
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/leaderboard/leaderboard.js